Namespace('Monitoring.LiveReports.RealtimeMapContainer')

class Monitoring.LiveReports.RealtimeMapDrilldownView extends Backbone.View
  modalTemplate: JST["backbone/templates/monitoring/live_reports/realtime_map/realtime_map_drilldown_modal"]

  initialize: (@options = {}) ->
    @endpointUrl = @options.endpointUrl
    @filterDefinition = @options.filterDefinition
    @accountId = @options.accountId

  render: ->
    @$el.html(@modalTemplate())

  show: ->
    @$el.find('#drilldown-modal').modal()
    @fetchAndAddContents()

  fetchAndAddContents: ->
    $.ajax
      type: 'POST'
      url: @endpointUrl
      global: false
      data: { filter_definition: @filterDefinition, account_id: @accountId }
      success: (response) =>
        if response.success
          @addContents(JSON.parse(response.result))
        else
          console.log('An error has occurred trying to get drilldown data')
      error: (response) =>
        console.log('An error has occurred trying to get drilldown data')

  addContents: (rawSocialContents) ->
    container = @$el.find('.drilldown-container')
    container.removeClass('processing')
    _.each(rawSocialContents.social_contents, (socialContent) =>
      view = Monitoring.Views.SocialContentViewFactory.create(socialContent, Keepcon.tags)
      container.append(view.render().el)
    )
